import Vue from 'vue'
import './plugins/vuetify'
import './plugins/authenticate'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;

const vm = new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

vm.$auth.isAuthenticated()